import React, { useCallback, useEffect, useState } from 'react';
import './extension-statistics-style.scss';
import moment from 'moment';
const Datepicker = ({ value, onChange, name, label }) => (<div>
    <label htmlFor={name}>{`${label}: `}</label>
    <input key={`date_${name}`} type="date" id={name} name={name} onChange={onChange} value={value} max={moment().format('YYYY-MM-DD')} onKeyDown={e => e.preventDefault()}/>
  </div>);
const InstitutionSelect = ({ institutions, value, onChange }) => {
    const selectItems = (institutions, search) => 
    // here we filter items according to search and take first 5 according to task description
    institutions
        .filter(institution => institution.name.toLowerCase().includes(search.toLowerCase()))
        .slice(0, 10);
    const [search, setSearch] = useState('');
    const [list, setList] = useState([]);
    const [isOpen, setOpen] = useState(false);
    useEffect(() => {
        setList(selectItems(institutions, search));
    }, [institutions, search]);
    const onSearch = useCallback(({ target: { value } }) => {
        setSearch(value);
        setOpen(true);
        if (value === '') {
            onSelect({ target: { value: null, id: '' } });
            setOpen(true);
        }
    }, [search]);
    const onSelect = useCallback(({ target: { value, id } }) => {
        setSearch(id);
        onChange({ target: { name: 'institutionId', value } });
        setOpen(false);
    }, [search]);
    const toggleOpen = useCallback(() => setOpen(!isOpen), [isOpen]);
    return (<div className="dropdown">
      <label htmlFor={search}> {`institution: `}</label>
      <input type="search" id={'search'} name={'search'} onChange={onSearch} onClick={toggleOpen} value={search} autoComplete="off"/>
      {list.length > 0 && (<span onClick={toggleOpen} className="arrow">
          {isOpen ? '▲' : '▼'}
        </span>)}
      {<ul className="dropdown-list">
          {isOpen &&
                (list.length > 0 ? (list.map(institution => (<li key={institution.id} id={institution.name} value={institution.id} onClick={onSelect}>
                  {`${institution.name}`}
                </li>))) : (<li key={'no matches'}>No matches found</li>))}
        </ul>}
    </div>);
};
export const StatisticFilterForm = ({ filterParams, onChange, institutions }) => {
    const selectDate = ({ target: { value: datepickerValue, name } }) => {
        onChange({ name, value: moment(datepickerValue) });
    };
    const selectInstitution = ({ target: { name, value } }) => {
        onChange({ name, value });
    };
    return (<div className="filter-form">
      <Datepicker value={filterParams.from.format('YYYY-MM-DD')} onChange={selectDate} name="from" label="from" key={`date_from`}/>
      <Datepicker value={filterParams.to.format('YYYY-MM-DD')} onChange={selectDate} name="to" label="to" key={`date_to`}/>
      <InstitutionSelect key="instselect" institutions={institutions} value={filterParams.institutionId} onChange={selectInstitution}/>
    </div>);
};
